import styles from './AcfSelect.module.scss';
import className from 'classnames/bind';
import { gql } from '@apollo/client';
import { FormButton, FormSelect } from '@/components';

let cx = className.bind(styles);

export default function AcfSelect(props) {
	const { select, attributes, id } = props;
	const className = attributes.className?.split(' ') || [];

	return (
		<FormSelect
			label={select.label}
			name={select.name}
			id={attributes.anchor || `input-${id}`}
			className={cx([attributes.alignSelect && `align-${attributes.alignSelect}`, ...className])}
			required={{
				value: select.required,
				message: select.requiredErrorMessage,
			}}
      multiple={select.multiple}
      size={select.size}
      >
			{select.options.map((option, index) => {
				if (option.fieldGroupName === 'SelectOptionsOptionGroupLayout') {
					return (
						<optgroup key={index} label={option.label}>
							{option.options.map((groupedOption, index) => (
								<option key={index} value={groupedOption.value}>
									{groupedOption.text}
								</option>
							))}
						</optgroup>
					);
				} else if (option.fieldGroupName === 'SelectOptionsOptionLayout') {
					return (
						<option key={index} value={option.value}>
							{option.text}
						</option>
					);
				}
			})}
		</FormSelect>
	);
}

AcfSelect.fragments = {
	key: `AcfSelectFragment`,
	entry: gql`
		fragment AcfSelectFragment on AcfSelect {
			attributes {
				anchor
				className
				alignSelect: align
			}
			select {
				name
				label
				required
				requiredErrorMessage
				multiple
				size
				options {
					fieldGroupName
					... on SelectOptionsOptionLayout {
						text
						value
					}
					... on SelectOptionsOptionGroupLayout {
						label
						options {
							text
							value
						}
					}
				}
			}
		}
	`,
};

AcfSelect.config = {
	name: 'AcfSelect',
};
AcfSelect.displayName = 'AcfSelect';
